import { render, staticRenderFns } from "./BankAccountList.vue?vue&type=template&id=63d0ef80&"
import script from "./BankAccountList.vue?vue&type=script&lang=js&"
export * from "./BankAccountList.vue?vue&type=script&lang=js&"
import style0 from "./BankAccountList.vue?vue&type=style&index=0&id=63d0ef80&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports